module.exports = __webpack_public_path__ + "img/conan-zemi.cf1b3226.png";